import { render, staticRenderFns } from "./DashboardLoginModal.vue?vue&type=template&id=37cdb71e&scoped=true&"
import script from "./DashboardLoginModal.vue?vue&type=script&lang=js&"
export * from "./DashboardLoginModal.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLoginModal.vue?vue&type=style&index=0&id=37cdb71e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cdb71e",
  null
  
)

export default component.exports